/** Frame bounded complete objects; semantic parsing remains the caller's job. */
export class ObjectFramer {
  private pending = "";
  private offset = 0;
  private depth = 0;
  private quoted = false;
  private escaped = false;
  constructor(private maximum: number) {}

  *feed(text: string): Generator<string> {
    this.pending += text;
    while (this.offset < this.pending.length) {
      if (this.offset === 0) {
        this.pending = this.pending.trimStart();
        if (!this.pending) break;
        if (this.pending[0] !== "{") throw new Error("Record must be a JSON object");
      }
      const char = this.pending[this.offset];
      if (this.quoted) {
        if (this.escaped) this.escaped = false;
        else if (char === "\\") this.escaped = true;
        else if (char === '"') this.quoted = false;
      } else if (char === '"') this.quoted = true;
      else if (char === "{" || char === "[") this.depth++;
      else if (char === "}" || char === "]") this.depth--;
      this.offset++;
      if (this.depth === 0) {
        const record = this.pending.slice(0, this.offset);
        this.pending = this.pending.slice(this.offset);
        this.offset = 0;
        if (new TextEncoder().encode(record).length > this.maximum) throw new Error("Line budget");
        yield record;
      }
    }
    if (new TextEncoder().encode(this.pending).length > this.maximum)
      throw new Error("Line budget");
  }

  finish() {
    if (this.pending.trim()) throw new Error("Truncated JSON object");
  }
}
